/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".dialog__radio-group[_ngcontent-%COMP%]{display:flex;flex-direction:column}@media (min-width:480px){.dialog[_ngcontent-%COMP%]{min-width:380px}}"];
export { styles as styles };
